import type { MaskOptions, TrackingData } from '@react-input/mask';

export const datetimeMaskModify = (
  { inputType, value }: TrackingData,
  maskOptions: MaskOptions,
  displayedDateTime: string
) => {
  let showMask = displayedDateTime !== '';
  if (inputType === 'insert' && value === '') {
    showMask = true;
  }
  return {
    ...maskOptions,
    showMask,
  };
};
